import { Controller } from "@hotwired/stimulus"

import AirDatepicker from "air-datepicker";
import localeEn from 'air-datepicker/locale/en';
import flatpickr from "flatpickr";

// Connects with data-controller="date-pickers"
export default class extends Controller {

    connect() {
      this.initDatepickers();
    }
  
    // Initialize all existing date/time pickers
    initDatepickers() {
      const timepickers = document.querySelectorAll('.timepicker');
      const datepickers = document.querySelectorAll('.datepicker');
      const datetimepickers = document.querySelectorAll('.datetimepicker');
      
      timepickers.forEach(el => this.initTimepicker(el));
      datepickers.forEach(el => this.initDatepicker(el));
      datetimepickers.forEach(el => this.initDatetimepicker(el));
    }
  
    initTimepicker(el) {
      if (!el._airDatepicker) {
        new AirDatepicker(el, {
          onlyTimepicker: true,
          timepicker: true,
          dateFormat: 'HH:mm',
          minutesStep: 5,
          //locale: localeEn,
          onSelect: ({date, formattedDate, datepicker}) => {
            datepicker.$el.value = formattedDate;
            datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }
  
    initDatepicker(el) {
      if (!el._airDatepicker) {
        new AirDatepicker(el, {
          timepicker: false,
          dateFormat: 'dd/M/yyyy',
          locale: localeEn,
          onSelect: ({date, formattedDate, datepicker}) => {
            datepicker.$el.value = formattedDate;
            datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }
    }

    initDatetimepicker(el) {
      if (!el._airDatepicker) {
        let defaultDate;
        if (el.value) {
          const [datePart, timePart] = el.value.split(' ');
          const [day, month, year] = datePart.split('/');
          const [hours, minutes] = timePart.split(':');
          defaultDate = new Date(
            year,
            month - 1,
            day,
            hours,
            minutes
          );
        }
        const picker = new AirDatepicker(el, {
          timepicker: true,
          dateFormat: 'dd/MM/yyyy',
          timeFormat: 'HH:mm',
          locale: localeEn,
          minutesStep: 5,
          defaultDate: defaultDate ? defaultDate : undefined,
          onSelect: ({date, formattedDate, datepicker}) => {
            datepicker.$el.value = formattedDate;
            datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        if (defaultDate) {
          picker.selectDate(defaultDate, { updateTime: true });
        }
      }
    }
}